import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { AccountSettingsTemplate } from 'components/Templates'

const Settings: FC = () => {
  return (
    <Layout headline={'商品の受け渡しに関する設定'} title={'商品の受け渡しに関する設定'}>
      <AccountSettingsTemplate />
    </Layout>
  )
}

export default Settings
